import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from "@angular/animations";
import { ToastService } from '../../services/toast.service';

@Component({
  selector: 'app-toast',
  templateUrl: './toast.component.html',
  styleUrls: ['./toast.component.css'],

  animations: [
    trigger('toastTrigger', [
      state('open', style({ transform: 'translateY(0%)' })),
      state('close', style({ transform: 'translateY(-200%)' })),
      transition('open <=> close', [
        animate('300ms ease-in-out')
      ])
    ])
  ]
})

export class ToastComponent implements OnInit {

  toastClass!: string[];
  toastTitle!: string;
  toastMessage!: string;
  showToast!: boolean;

  constructor( public toastService: ToastService ) {}

  ngOnInit(
  ) { 
  }

  dismiss(): void {
    this.toastService.dismissToast();
  }
}
